import { useTranslation } from "react-i18next";
import { ItemMenu } from "../../../../../../../../components/baseMenu";
import { Status } from "../../../../../../../../utils/enums";
import { removeAllReference } from "../../../../../../../../utils/methods/removedReference";
import { reportFolioDetailMenuType } from "../../enums";

const useMenuList = (): ItemMenu[] => {
    const { t } = useTranslation()
    let menu = [
        {
            label: t('general.edit'),
            value: reportFolioDetailMenuType.EDIT
        },
        {
            label: t('general.reassignUser'),
            value: reportFolioDetailMenuType.REASIGN_USER
        },
        {
            label: t('general.reassignAreaAndDepartment'),
            value: reportFolioDetailMenuType.REASSIGN_AREA_DEPARTMENT
        },
        {
            label: t('general.cancel'),
            value: reportFolioDetailMenuType.CANCEL
        },
        {
            label: t('general.seeReport'),
            value: reportFolioDetailMenuType.SEE_REPORT,
        },
        {
            label: t('general.resendReport'),
            value: reportFolioDetailMenuType.RESEND_REPORT,
        },
    ]
    return removeAllReference(menu)
}


const validateLifeCicleStatus = [
    Status.RESPONDED,
    Status.AWAIT_SOLUTION,
    Status.CANCEL,
    Status.EXPIRED,
    Status.NOT_FINISHED
]

const hiddenSetting = [

]
export { useMenuList, validateLifeCicleStatus, hiddenSetting }
